import { render, staticRenderFns } from "./CourseMapping.vue?vue&type=template&id=927c9384&"
import script from "./CourseMapping.vue?vue&type=script&lang=ts&"
export * from "./CourseMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports